import { useEffect, useState } from 'react';
import { AccessibilityInfo } from 'react-native';

// Issue #147 AC4. Reanimated's own withTiming/withSpring (the native
// press-spring driver, #146/#195) already default `reduceMotion` to
// `ReduceMotion.System`, which reads the OS accessibility setting on
// native for free -- confirmed by @tamagui/animations-reanimated's own
// createAnimations implementation, not re-solved here. The real gap
// this hook closes is everything that ISN'T that driver: web's CSS
// transitions (which never automatically respect
// `prefers-reduced-motion` -- that's a real CSS fact, not an oversight
// -- a `transition` property keeps animating regardless of the media
// query unless something explicitly checks it) and Skeleton's own
// setInterval-driven opacity pulse (plain JS, no awareness of any
// accessibility setting at all).
//
// `AccessibilityInfo.isReduceMotionEnabled` + the `reduceMotionChanged`
// event, not a raw `matchMedia` call -- this is RN's own cross-platform
// accessibility API, which react-native-web implements by wrapping
// exactly that `matchMedia('(prefers-reduced-motion: reduce)')` query
// under the hood, so one hook covers native's real OS setting AND
// web's CSS media feature through the same call, rather than
// maintaining two separate checks.
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    let mounted = true;
    AccessibilityInfo.isReduceMotionEnabled().then((value) => {
      if (mounted) setReduced(value);
    });

    const subscription = AccessibilityInfo.addEventListener('reduceMotionChanged', setReduced);
    return () => {
      mounted = false;
      subscription.remove();
    };
  }, []);

  return reduced;
}
